import { StaffDetailsEffects } from './staff-details.effects';
import { CallCentreStatusEffects } from './call-centre-status.effects';
import { ComplianceSummaryEffects } from './compliance-summary.effects';
import { NmcNmbiStatusEffects } from './nmc-nmbi-status.effects';
import { PayRatesEffects } from './pay-rates.effects';
import { WelcomePackEffects } from './welcome-pack.effects';
import { FirstShiftAppointmentStatusEffects } from './first-shift-appointment-status.effects';
import { AdvancePreferencesEffects } from './advance-preferences.effects';

export const featureEffects = [
  CallCentreStatusEffects,
  ComplianceSummaryEffects,
  NmcNmbiStatusEffects,
  PayRatesEffects,
  StaffDetailsEffects,
  WelcomePackEffects,
  FirstShiftAppointmentStatusEffects,
  AdvancePreferencesEffects,
];
